import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import {
  getChargeDiscountMode,
  postBrandChargeDiscount,
  putBrandChargeDiscount,
} from "../../../services/ChargeDiscount.js/chargeDiscount";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";

const ChargesAndDiscountModal = ({
  chargesAndDiscountModalVisible,
  setChargesAndDiscountModalVisible,
  sendDataToChargesAndDiscountModal,
  brandId,
  selectedPackageItemValue,
  type,
}) => {
  const navigate = useNavigate();
  const [nameValue, setNameValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [chargeDiscountValue, setChargeDiscountValue] = useState("");
  const [chargeDiscountTypeValue, setChargeDiscountTypeValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState(null);
  const [chargeDiscountTypeInValue, setChargeDiscountTypeInValue] =
    useState("");
  const [chargeDiscountModeValue, setChargeDiscountModeValue] = useState("");

  const [nameError, setNameError] = useState("");
  const [chargeDiscountError, setChargeDiscountError] = useState("");
  const [chargeDiscountTypeError, setChargeDiscountTypeError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [chargeDiscountTypeInError, setChargeDiscountTypeInError] =
    useState("");
  const [chargeDiscountModeError, setChargeDiscountModeError] = useState("");

  const [modeData, setModeData] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const chargeDiscountTypeItems = [
    {
      name: "CHARGE",
      value: "CHARGE",
    },
    {
      name: "DISCOUNT",
      value: "DISCOUNT",
    },
  ];

  const chargeDiscountTypeInItems = [
    {
      name: "AMOUNT",
      value: "AMOUNT",
    },
    {
      name: "PERCENTAGE",
      value: "PERCENTAGE",
    },
  ];

  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  const fetchChargeDiscountMode = () => {
    getChargeDiscountMode()
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;

          const ModifiedModeDate = res.map((item) => ({
            name: item,
            value: item,
          }));

          setModeData(ModifiedModeDate);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchChargeDiscountMode();
  }, []);

  useEffect(() => {
    if (selectedPackageItemValue !== null) {
      setNameValue(selectedPackageItemValue?.name || "");
      setChargeDiscountValue(
        selectedPackageItemValue?.chargeDiscount.toString() || ""
      );
      setChargeDiscountTypeValue(
        selectedPackageItemValue?.chargeDiscountType || ""
      );
      setDescriptionValue(
        selectedPackageItemValue?.description.toString() || ""
      );
      setChargeDiscountTypeInValue(
        selectedPackageItemValue?.chargeDiscountTypeIn || ""
      );
      setChargeDiscountModeValue(
        selectedPackageItemValue?.chargeDiscountMode || ""
      );
      setStatusValue(selectedPackageItemValue?.status || false);
    }
  }, [selectedPackageItemValue]);

  const handleConfirmPickup = () => {
    // Reset all previous errors

    setNameError("");
    setChargeDiscountError("");
    setChargeDiscountTypeError("");
    setDescriptionError("");
    setChargeDiscountTypeInError("");
    setChargeDiscountModeError("");

    let isValid = true;
    if (!nameValue) {
      setNameError("Name is required");
      isValid = false;
    }
    if (!chargeDiscountValue) {
      setChargeDiscountError("Value is required");
      isValid = false;
    }
    if (!chargeDiscountTypeValue) {
      setChargeDiscountTypeError("Charges & Discount Type is required");
      isValid = false;
    }
    if (!descriptionValue) {
      setDescriptionError("Description is required");
      isValid = false;
    }
    if (!chargeDiscountTypeInValue) {
      setChargeDiscountTypeInError("Charges & Discount Type In is required");
      isValid = false;
    }
    if (!chargeDiscountModeValue) {
      setChargeDiscountModeError("Charges & Discount Type In is required");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedPackageItemValue === null) {
          const data = {
            brandId: brandId,
            name: nameValue,
            chargeDiscount: chargeDiscountValue,
            chargeDiscountType: chargeDiscountTypeValue,
            description: descriptionValue,
            chargeDiscountTypeIn: chargeDiscountTypeInValue,
            chargeDiscountMode: chargeDiscountModeValue,
            status: true
          };

          postBrandChargeDiscount(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setChargeDiscountValue("");
                  setChargeDiscountTypeValue("");
                  setDescriptionValue("");
                  setChargeDiscountTypeInValue("");
                  setChargeDiscountModeValue("");

                  setNameError("");
                  setChargeDiscountError("");
                  setChargeDiscountTypeError("");
                  setDescriptionError("");
                  setChargeDiscountTypeInError("");
                  setChargeDiscountModeError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToChargesAndDiscountModal({
                    success: true,
                  });
                  setChargesAndDiscountModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            ...selectedPackageItemValue,
            brandId: brandId,
            name: nameValue,
            chargeDiscount: chargeDiscountValue,
            chargeDiscountType: chargeDiscountTypeValue,
            description: descriptionValue,
            chargeDiscountTypeIn: chargeDiscountTypeInValue,
            chargeDiscountMode: chargeDiscountModeValue,
            status:statusValue
          };
          putBrandChargeDiscount(brandId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setChargeDiscountValue("");
                  setChargeDiscountTypeValue("");
                  setDescriptionValue("");
                  setChargeDiscountTypeInValue("");
                  setChargeDiscountModeValue("");

                  setStatusValue("");
                  setNameError("");
                  setChargeDiscountError("");
                  setChargeDiscountTypeError("");
                  setDescriptionError("");
                  setChargeDiscountTypeInError("");
                  setChargeDiscountModeError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToChargesAndDiscountModal({
                    success: true,
                  });
                  setChargesAndDiscountModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const handleModalClose = () => {
    setNameValue("");
    setChargeDiscountValue("");
    setChargeDiscountTypeValue("");
    setDescriptionValue("");
    setChargeDiscountTypeInValue("");
    setChargeDiscountModeValue("");
    setStatusValue("");

    setNameError("");
    setChargeDiscountError("");
    setChargeDiscountTypeError("");
    setDescriptionError("");
    setChargeDiscountTypeInError("");
    setChargeDiscountModeError("");
    setIsSubmitButtonPressed(false);
    sendDataToChargesAndDiscountModal({
      success: true,
    });
    setChargesAndDiscountModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={chargesAndDiscountModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!chargesAndDiscountModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                {selectedPackageItemValue === null ? "ADD NEW" : "Edit"}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div
              className="scroll-bar mb-2"
              style={{
                height:400,
                overflowY: "scroll",
              }}
            >
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <InputText
                    id="name"
                    value={nameValue}
                    onChange={(e) => setNameValue(e.target.value)}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    placeholder="Name"
                  />
                  <label
                    htmlFor="name"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  {nameError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {nameError}
                    </p>
                  )}
                </FloatLabel>
              </div>
              <div className="mx-4 mt-4  ">
                <FloatLabel>
                  <InputText
                    id="value"
                    value={chargeDiscountValue}
                    onChange={(e) => setChargeDiscountValue(e.target.value)}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    placeholder="Value"
                  />
                  <label
                    htmlFor="value"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Value <span style={{ color: "red" }}>*</span>
                  </label>
                  {chargeDiscountError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {chargeDiscountError}
                    </p>
                  )}
                </FloatLabel>
              </div>

              <div className="mx-4 mt-4  ">
                <FloatLabel>
                  <Dropdown
                    id="chargeDiscountModeValue"
                    value={chargeDiscountModeValue}
                    onChange={(e) => setChargeDiscountModeValue(e.value)}
                    options={modeData}
                    optionLabel="name"
                    placeholder="Mode"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                  {chargeDiscountModeError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {chargeDiscountModeError}
                    </p>
                  )}
                  <label
                    htmlFor="chargeDiscountModeValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Mode
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>
              <div className="mx-4 mt-4  ">
                <FloatLabel>
                  <Dropdown
                    id="chargeDiscountTypeValue"
                    value={chargeDiscountTypeValue}
                    onChange={(e) => setChargeDiscountTypeValue(e.value)}
                    options={chargeDiscountTypeItems}
                    optionLabel="name"
                    placeholder="Type"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                  {chargeDiscountTypeError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {chargeDiscountTypeError}
                    </p>
                  )}
                  <label
                    htmlFor="chargeDiscountTypeValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Type
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>
              <div className="mx-4 mt-4  ">
                <FloatLabel>
                  <Dropdown
                    id="chargeDiscountTypeInValue"
                    value={chargeDiscountTypeInValue}
                    onChange={(e) => setChargeDiscountTypeInValue(e.value)}
                    options={chargeDiscountTypeInItems}
                    optionLabel="name"
                    placeholder={
                      chargeDiscountTypeValue === "CHARGE"
                        ? "Charge Type In"
                        : chargeDiscountTypeValue === "DISCOUNT"
                        ? "Discount Type In"
                        : "Type In"
                    }
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                  {chargeDiscountTypeInError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {chargeDiscountTypeInError}
                    </p>
                  )}
                  <label
                    htmlFor="chargeDiscountTypeInValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    {chargeDiscountTypeValue === "CHARGE"
                      ? "Charge Type In"
                      : chargeDiscountTypeValue === "DISCOUNT"
                      ? "Discount Type In"
                      : "Type In"}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>

              <div className="mx-4 mt-4">
                <FloatLabel>
                  <InputText
                    id="descriptionValue"
                    value={descriptionValue}
                    onChange={(e) => setDescriptionValue(e.target.value)}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    placeholder="Description"
                  />
                  <label
                    htmlFor="descriptionValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Description <span style={{ color: "red" }}>*</span>
                  </label>
                  {descriptionError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {descriptionError}
                    </p>
                  )}
                </FloatLabel>
              </div>
              {selectedPackageItemValue !== null && (
                  <div className="mx-4 mt-4  ">
                    <FloatLabel>
                      <Dropdown
                        id="statusValue"
                        value={statusValue}
                        onChange={(e) => setStatusValue(e.value)}
                        options={statusItems}
                        optionLabel="name"
                        placeholder="Status"
                        className="w-full border-round-xl  text-2xl text-xl shadow-2"
                      />
                      <label
                        htmlFor="statusValue"
                        className="text-md"
                        style={{ color: "blue" }}
                      >
                        Status
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>
                )}
            </div>
              <Button
                className="mt-1 mb-3 mx-4 border-round-xl "
                onClick={handleConfirmPickup}
                disabled={isSubmitButtonPressed}
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Submit
                </p>
              </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default ChargesAndDiscountModal;
